import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { filter, Observable, of, switchMap, take } from 'rxjs';

type StoreHelperOptions = {
  takeOne?: boolean;
};

@Injectable({
  providedIn: 'root',
})
export class StoreHelperService {
  constructor(private store: Store) {}

  getAllDispatchAndSelect<T>(
    action: any,
    selector: () => (state: any) => T,
    options?: StoreHelperOptions
  ): Observable<T>;
  getAllDispatchAndSelect(
    action: any,
    selector?: undefined,
    options?: StoreHelperOptions
  ): Observable<void>;

  getAllDispatchAndSelect<T>(
    action: any,
    selector?: () => (state: any) => T,
    options: StoreHelperOptions = {}
  ): Observable<T | void> {
    const { takeOne = false } = options;

    return this.store.dispatch(action).pipe(
      switchMap(() => {
        if (selector) {
          let stream = this.store
            .select(selector())
            .pipe(filter((data) => !!data));
          if (takeOne) {
            stream = stream.pipe(take(1));
          }
          return stream;
        } else {
          return of(void 0);
        }
      })
    );
  }
}
